var React = require('react');

function BlobTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M41.7523 0.0967207C33.8268 0.982392 29.8122 9.79752 23.7034 14.9401C18.1758 19.5933 11.4742 22.5929 7.70002 28.7628C3.1057 36.2733 -0.867722 44.6683 0.16494 53.4193C1.3135 63.1524 5.50109 73.2555 13.5976 78.7402C21.6111 84.1687 32.2816 83.5467 41.7523 81.5914C49.9566 79.8976 55.685 73.3938 62.5831 68.627C69.7206 63.6948 80.9826 61.7431 82.7832 53.2379C84.6115 44.6018 74.3814 38.4414 70.668 30.4372C67.6026 23.8296 68.0003 15.8188 62.9799 10.551C57.3959 4.69182 49.7828 -0.800683 41.7523 0.0967207Z","fill":"#FECB4B"}));
}

BlobTop.defaultProps = {"width":"83","height":"83","viewBox":"0 0 83 83","fill":"none"};

module.exports = BlobTop;

BlobTop.default = BlobTop;
